__webpack_require__.p = "https://vb-example-component-production.s3.eu-west-1.amazonaws.com/3.1.07/";